<template>
  <div
    v-loading="isLoading"
    :class="isLoading ? 'f-df' : ''"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    class="manage-table-list-wrap white-bg pd-btm15 f-pr">
    <!--表格整体操作-->
    <section v-if="selection.length" class="table-total-opration f-df f-ai pd10">
      <i class="el-icon-warning color-lighter-gray mg-right10"></i>
      <span class="pd-right30">已选择 {{ selection.length }} 项</span>
      <span class="f-csp color-lighter-gray pd-row15 f-pr clear-checked-btn" @click="clearSelect()">清空</span>
      <el-button
        v-for="(item, index) in tableBatchBtn"
        :key="index"
        v-show="!item.isHide"
        type="text"
        class="mg-left15 archeive-btn bg-white color-dark"
        @click="batchOperationBtn(item)">
        {{ item.name }}
      </el-button>
    </section>
    <!--表格内容-->
    <el-table
      ref="table"
      :data="pageList"
      :default-sort = "defaultSort"
      :row-class-name="tableRowClassName"
      tooltip-effect="dark"
      stripe
      border
      :style="{minHeight: tableMinHei}"
      style="width: 100%; border-top: 1px solid #F1F4F7;"
      class="f-csp"
      @selection-change="selectionChange"
      @sort-change="sortChange"
      @row-click="rowClick">
      <!--多选check-->
      <el-table-column
        v-if="isShowSelection"
        type="selection"
        width="55"
        class="icon-row-check" />
      <!--详情信息-->
      <el-table-column
        v-for="(item, index) in tableHead"
        :key="index"
        :label="item.label"
        :prop="item.key"
        :width="item.rightWidth || item.width"
        :min-width="item.minWidth || 120"
        :fixed="item.fixed"
        :sortable="item.isSort ? 'custom' : false"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-if="item.type === 'switch'">
            <el-switch
              v-model="scope.row.state"
              :active-value="1"
              :inactive-value="2"
              active-color="#478500"
              inactive-color="#C6D0DA"
              @change="enabledSwitch(scope.row)" />
            <span class="enabled mg-left5">
              {{ scope.row.state === 1 ? "开启" : "关闭" }}
            </span>
          </div>
          <div v-else-if="item.isHtml" v-html="scope.row[item.key]"></div>
          <div
            v-else
            :class="item.isLink ? 'txt-link' : ''"
            class="f-toe"
            @click="outLink(item, scope.row)">
            {{ scope.row[item.key] || scope.row[item.key] === 0 ? scope.row[item.key] : '-' }}
          </div>
        </template>
        <el-table-column
          v-for="(elem, i) in item.children"
          :key="i"
          :label="elem.label"
          :prop="elem.key"
          :width="elem.width || 100"
          :min-width="elem.minWidth || 150"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table-column>
      <!--表头操作-->
      <el-table-column v-if="isTableOperationBtn" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <div class="f-df f-ai f-jc">
            <div
              v-for="(item, index) in tableBtn"
              :key="index"
              class="f-tac">
              <span
                v-if="model === 'scaleManage'"
                :class="index < tableBtn.length - 1 ? 'mg-right20' : ''"
                class="table-opration-btn color-blue f-tal f-csp"
                @click.stop="rowOperatBtn(scope.row, item)">
                {{ item.name }}
              </span>
              <span
                v-else-if="!((item.id === 'archive' || item.id === 'delete') && scope.row.isFileStr=== '已归档')"
                :class="{
                  'color-light-gray': item.id === 'delete',
                  'color-blue': item.id !== 'delete',
                  'mg-right20': index < tableBtn.length - 1
                }"
                class="table-opration-btn f-tal f-csp"
                @click.stop="rowOperatBtn(scope.row, item)">
                {{ item.name }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div v-if="isShowPagination" class="f-tar pagination mg-top15">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableMinHei: {
      type: String,
      default: '530px'
    },
    model: {
      type: String,
      default: ''
    },
    isShowPagination: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isShowListHead: {
      type: Boolean,
      default: true
    },
    placeholderTxt: {
      type: String,
      default: '订单数据'
    },
    isShowSelection: {
      type: Boolean,
      default: true
    },
    isShowExportBtn: {
      type: Boolean,
      default: true
    },
    exportTxt: {
      type: String,
      default: '导出数据'
    },
    isTableOperationBtn: {
      type: Boolean,
      default: false
    },
    defaultSort: {
      type: Object,
      default: () => {
        return {}
      }
    },
    tableBatchBtn: {
      type: Array,
      default: () => []
    },
    tableHead: {
      type: Array,
      default: () => []
    },
    tableBtn: {
      type: Array,
      default: () => []
    },
    pageList: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    totalSize: {
      type: Number,
      default: 0
    },
    isShowClickRowClass: {
      type: Boolean,
      default: false
    },
    activeRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selection: []
    }
  },
  methods: {
    // 显示当前活动行
    tableRowClassName({ row, rowIndex }) {
      if (this.isShowClickRowClass && row.$index === this.activeRow.$index) {
        return 'warning-row'
      }
      return ''
    },
    // 点击行
    rowClick(row, column, event) {
      this.$emit('rowClick', row, column, event)
    },
    // 调整到外链
    outLink(item, rowItem) {
      if (item.isLink && item.linkKey) {
        window.open(rowItem[item.linkKey])
      }
    },
    // check选择
    selectionChange(selection) {
      this.selection = selection || []
    },
    // 清空所有选择
    clearSelect() {
      this.$refs.table.clearSelection()
    },
    // 批量发布
    batchOperationBtn(item) {
      if (!this.selection.length) {
        // 发布保存操作
        this.$message({
          type: 'warning',
          message: '请选择后再批量操作'
        })
        return
      }
      this.$confirm('<div class="confirm-box"><span class="color-blue">' + this.selection.length + '</span>' + (item.warnTxt || '条数据批量操作') + '</div>', item.confirmButtonText || item.name || '', {
        confirmButtonText: item.confirmButtonText || '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit('batchOperationBtn', item, this.selection)
      })
      // this.$emit('batchArchive', this.selection)
    },
    // 行按钮点击
    rowOperatBtn(row, item) {
      if (item.isNoConfirm) {
        this.$emit('rowOperatBtn', [row], item)
        return
      }
      const txt = '确定' + item.name + '吗？'
      this.$confirm('<div class="confirm-box">' + (item.warnTxt || txt) + '</div>', item.name || '', {
        confirmButtonText: item.name,
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit('rowOperatBtn', [row], item)
      })
    },
    // 分页条数改变
    handleSizeChange(pageSize) {
      this.$emit('sizeChange', pageSize)
    },
    // 当前页码修改
    handleCurrentChange(currentSize) {
      this.$emit('currentChange', currentSize)
    },
    // 排序修改
    sortChange(column) {
      this.$emit('sortChange', column)
    },
    // 下拉修改
    selectChange(item) {
      this.$emit('tableHeadChange', item)
    },
    // 状态修改
    enabledSwitch(row) {
      this.$emit('enabledSwitch', row)
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/color.less';
.manage-table-list-wrap .el-table th.el-table__cell>.cell,
.el-table td.el-table__cell{
  text-align: center;
}
.width100{
  width: 80px;
  text-align: right;
}
</style>
<style lang="less" scoped>
.manage-table-list-wrap{
  & .table-total-opration{
    background-color: #F8F9FB;
    & .clear-checked-btn::after{
      content: '';
      position: absolute;
      border-right: 1px solid #ddd;
      height: 100%;
      width: 1px;
      right: 0;
    }
    & .archeive-btn{
      border: 1px solid #C6D0DA;
      padding: 5px;
    }
  }
  & .el-table-column--selection{
    padding-left: 10px;
  }
  & .status-item{
    padding: 2px 12px;
    border-radius: 100px;
  }
  & .select-box{
    left: 0%;
  }
  & .txt-link:hover{
    color: #326CFA;
    cursor: pointer;
    text-decoration: underline;
  }
}
/deep/.el-table__header-wrapper .el-input__inner,
/deep/.el-table__header-wrapper .el-input__icon{
  height: 34px;
  line-height: 34px;
}
/deep/.el-table__header-wrapper .el-select>.el-input{
  opacity: 0;
}
/deep/.el-table .warning-row td.el-table__cell{
  background: oldlace!important;
}
</style>
